<template>
  <div class="country-code-select" ref="selectContainer">
    <div class="selected-country" @click="toggleDropdown" :class="{ 'open': isOpen }">
      <span class="flag">{{ selectedCountry.flag }}</span>
      <span class="code">{{ selectedCountry.code }}</span>
      <span class="arrow">&#9660;</span>
    </div>
    
    <div v-if="isOpen" class="dropdown-container" ref="dropdownContainer">
      <div class="dropdown">
        <div class="search-container">
          <input 
            type="text" 
            v-model="searchQuery" 
            :placeholder="searchPlaceholder"
            class="search-input"
            ref="searchInput"
          />
        </div>
      </div>
      
      <div class="dropdown-liste">
        <div class="options-container">
          <div 
            v-for="country in filteredCountries" 
            :key="country.iso2"
            class="option"
            @click="selectCountry(country)"
            :class="{ 'selected': country.code === selectedCountry.code }"
          >
            <span class="flag">{{ country.flag }}</span>
            <span class="code">{{ country.code }}</span>
            <span class="country-name">{{ country.country }}</span>
            <span v-if="country.code === selectedCountry.code" class="checkmark">✓</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntlNumber from '../common/intlNumber.json'

export default {
  name: 'CountryCodeSelect',
  props: {
    value: {
      type: String,
      default: '+221'
    },
    searchPlaceholder: {
      type: String,
      default: 'Rechercher un pays...'
    }
  },
  data() {
    return {
      isOpen: false,
      searchQuery: '',
      countries: IntlNumber
    }
  },
  computed: {
    selectedCountry() {
      return this.countries.find(country => country.code === this.value) || this.countries.find(country => country.code === '+221')
    },
    filteredCountries() {
      if (!this.searchQuery) {
        return this.countries
      }
      const query = this.searchQuery.toLowerCase()
      return this.countries.filter(country => 
        country.country.toLowerCase().includes(query) ||
        country.code.includes(query)
      )
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      } else {
        this.searchQuery = ''
      }
    },
    selectCountry(country) {
      this.$emit('input', country.code)
      this.isOpen = false
      this.searchQuery = ''
    },
    handleClickOutside(event) {
      const container = this.$refs.selectContainer
      if (container && !container.contains(event.target)) {
        this.isOpen = false
        this.searchQuery = ''
      }
    }
  }
}
</script>

<style scoped>
.country-code-select {
  position: relative;
  width: 120px;
}

.selected-country {
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  gap: 8px;
  max-height: 47px;
  box-sizing: border-box;
}

.selected-country:hover {
  border-color: #ffa409;
}

.selected-country.open {
  border-color: #ffa409;
  
}

.flag {
  font-size: 16px;
}

.code {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  /* flex: 1; */
}

.arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s;
}

.selected-country.open .arrow {
  transform: rotate(180deg);
}

.dropdown-container {
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  z-index: 2;
  background: white;
  border: 1px solid #ffa409;
  /* border-top: none; */
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow: hidden;
  width: max-content;
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.search-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.search-input:focus {
  border-color: #ffa409;
}

.dropdown-liste {
  max-height: 200px;
  overflow-y: auto;
}

.options-container {
  padding: 0;
}

.option {
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  gap: 4px;
  border-bottom: 1px solid #f5f5f5;
}

.option:hover {
  background-color: #f8f9fa;
}

.option.selected {
  background-color: #fff3e0;
  color: #ffa409;
}

.option .flag {
  font-size: 16px;
}

.option .code {
  font-weight: 500;
  min-width: 50px;
}

.option .country-name {
  flex: 1;
  font-size: 12px;
}

.checkmark {
  color: #ffa409;
  font-weight: bold;
}

/* Scrollbar styling */
.dropdown-liste::-webkit-scrollbar {
  width: 6px;
}

.dropdown-liste::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.dropdown-liste::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dropdown-liste::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>